// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","802":"94726e6d","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"4e2bcdd71b6a475d3d71","716":"f04d55e2ba0d26617a1c","731":"f31e48811ad7a71acdc5","802":"d146ca2034772f5294a6","843":"2a5e48422ee54c3b3eb4","883":"48614d02cd3e19361a43"}[chunkId] + ".js";
};